export const ALLOWED_FILE_EXTENSIONS = ["csv", "xlsx"];

export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;

export const hasAllowedExtension = (file: File): boolean => {
    const extension = file.name.split(".").pop()?.toLowerCase();
    return Boolean(extension && ALLOWED_FILE_EXTENSIONS.includes(extension));
};
